<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />

        <input-text
            label="* Rating (score from 0 to 5 including decimals)"
            name="rating"
            type="number"
            :step="0.1"
            class="mt-3"
            v-model="form.rating"
            :error="errors.rating ? errors.rating[0] : null"
        />

        <input-text
            class="mt-3"
            name="disadvantage_1"
            label="Disadvantage 1"
            v-model="form.disadvantage_1"
            :error="errors.disadvantage_1 ? errors.disadvantage_1[0] : null"
            :maxlength="255"
        />

        <input-text
            class="mt-3"
            name="disadvantage_2"
            label="Disadvantage 2"
            v-model="form.disadvantage_2"
            :error="errors.disadvantage_2 ? errors.disadvantage_2[0] : null"
            :maxlength="255"
        />

        <input-text
            class="mt-3"
            name="disadvantage_3"
            label="Disadvantage 3"
            v-model="form.disadvantage_3"
            :error="errors.disadvantage_3 ? errors.disadvantage_3[0] : null"
            :maxlength="255"
        />

        <media-reference
            :language="form.language"
            v-model="form.logo"
            class="mt-3"
            label="Logo"
            :media-types="['OperatorLogo']"
            name="logo_id"
            :error="errors.logo_id ? errors.logo_id[0] : null"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    name: "BlacklistedCasinoForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                rating: this.getFormData("rating"),
                disadvantage_1: this.getFormData("disadvantage_1"),
                disadvantage_2: this.getFormData("disadvantage_2"),
                disadvantage_3: this.getFormData("disadvantage_3"),
                logo: this.getFormData("logo"),
                logo_id: this.getFormData("logo_id"),
            },
        };
    },
    watch: {
        "form.logo": function(newValue){
            this.form.logo_id = newValue?.id || null
        },
    },
};
</script>
